export default "__VITE_ASSET__BNaNEaqF__"